import type { CardItemBreedSeoProps } from '@presentation/components';
import { CardItem } from '@presentation/components';
import { PLACEHOLDER_IMAGE_DOG } from '@presentation/constants';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import * as Styled from './styled';

export * from './types';

export const CardItemBreedSeo: FC<CardItemBreedSeoProps> = (props) => {
  const { breedName, image, link, ...rest } = props;
  const { translate } = useTranslation();

  return (
    <CardItem
      link={link}
      image={image ?? PLACEHOLDER_IMAGE_DOG}
      footer={translate('common.buttons.details')}
      {...rest}
    >
      <Styled.Title as="h3">
        {translate('breederDetails.breeds.card.title').replaceAll('$breed', breedName)}
      </Styled.Title>
      <Styled.Text>
        {translate('breederDetails.breeds.card.text').replaceAll('$breed', breedName)}
      </Styled.Text>
    </CardItem>
  );
};
